import WhiteTiger from "images/white-tiger.png";
import CrmSheet from "images/crmsheet.png";

export function getLogoSrc() {
  return window.location.host.includes("crmsheet") ? CrmSheet : WhiteTiger;
}

export function getTitle() {
  return window.location.host.includes("crmsheet") ? "CRMSheet" : "Tigersheet";
}